import { AppShell, useMantineTheme } from "@mantine/core";
import Footer from "./Footer";
import Header from "./Header";
import {
  ContactUs,
  Introduction,
  OurCustomer,
  OurService,
  Pricing,
} from "./Sections";
import ShowCase from "./ShowCase/ShowCase";
import { CONTACT } from "./demo";

export default function ApplicationShell() {
  const theme = useMantineTheme();
  return (
    <AppShell
      styles={{
        main: {
          background:
            theme.colorScheme === "dark"
              ? theme.colors.dark[8]
              : theme.colors.gray[0],
        },
      }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      footer={
        <Footer
          whatsappLink={CONTACT.whatsappHref}
          facebookLink={CONTACT.facebookHref}
        />
      }
      header={<Header />}
    >
      <ShowCase />
      <Introduction id="關於我們" />
      <br />
      <OurService id="服務" />
      <br />
      <Pricing id="收費" />
      <br />
      <ContactUs id="聯絡我們" />
      <br />
      <OurCustomer id="客戶" />
      <br />
    </AppShell>
  );
}
